import RatePlanCard from "./RatePlanCard";
import { TbTag } from "react-icons/tb";

const RatePlanGrid = ({ ratePlans, handleEdit, handleDelete }) => {
  if (ratePlans.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3">
        <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center">
          <TbTag className="text-gray-300 text-2xl" />
        </div>
        <p className="text-sm font-semibold text-gray-400">Aucun tarif créé</p>
        <p className="text-xs text-gray-300">Créez votre premier plan tarifaire pour commencer</p>
      </div>
    );
  }

  return (
    /* Colonnes entre 260 et 300px : jamais trop fines, jamais étirées.
       auto-rows-[max-content] + content-start : les cartes gardent la hauteur
       de leur contenu au lieu de s'étirer sur la hauteur du conteneur. */
    <div className="grid gap-4 mt-2 grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(260px,300px))] justify-start content-start auto-rows-[max-content]">
      {ratePlans.map((plan) => (
        <RatePlanCard
          key={plan._id}
          plan={plan}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  );
};

export default RatePlanGrid;